<template>
  <div class="materialAdmin">
    <div class="head-title">新客欢迎语</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、企业可以根据不同的活动场景，在此处添加文字、图片、图文链接及小程序，让客户在添加的第一时间，感受到温暖的服务。
          </p>
          <p>
            2、每个企业成员均可以拥有不同的欢迎语。此功能充分体现了企业个性，满足多场景新客欢迎语的使用，帮助企业实现精细化运营，快速转化。
            <a
              class="help-link"
              href="https://www.weijub.com/index/index/news_detail?id=124"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <div class="header-menu">
        <div class="menu-left">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建欢迎语</el-button
          >
        </div>
        <div>
          <el-input
            clearable
            style="width: 35.0rem; "
            prefix-icon="el-icon-search"
            placeholder="请输入欢迎语内容搜索"
            v-model="searchVal"
            @change="onSearch"
          >
          <el-button type="primary" slot="append" @click="onSearch"
            >查询</el-button
          >
          </el-input>

        </div>
      </div>
      <div class="container">
        <el-table :data="tableData" v-loading="tableLoading" border >
          <el-table-column
            label="发送对象"
            prop="scope_name"
            style="width: 14.28%;"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="欢迎语内容"
            prop="content"
            style="width: 14.28%;"
          ></el-table-column>
          <el-table-column label="适用成员" prop="user_name"  style="width: 14.28%;">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                style="margin: .2rem"
                v-for="t in scope.row.user_name_array"
                :key="t"
                >{{ t }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            label="欢迎语类型"
            prop="state_name"
            style="width: 14.28%;"
          ></el-table-column>
          <el-table-column label="附件类型"  style="width: 14.28%;">
            <template slot-scope="scope">
              <template v-if="scope.row.msgtype_name_array.length > 0">
                <el-tag
                  size="mini"
                  style="margin: .2rem"
                  v-for="t in scope.row.msgtype_name_array"
                  :key="t"
                  >{{ t }}</el-tag
                >
              </template>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"  style="width: 14.28%;">
            <template slot-scope="scope">
              <span style="margin-left: 1.0rem">{{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"  fixed="right" width="200" >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click.stop="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
              size="mini"
                type="text"
                style="color:#f00000;"
                @click="handleDelete(scope.$index, scope.row)"
                v-if="scope.row.state == 0"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          @pagination="getData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";

export default {
  name: "mine",
  components: {
    pagination,
  },
  data() {
    return {
      searchVal: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      title: "",
      tableLoading: true
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getData();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    getData() {
      this.axios
        .post(
          "/crm/AssistantWelcomeNew/getWelcome",
          qs.stringify({
            account_id: this.tooken.account_id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            content: this.searchVal,
            state: this.$route.query.state,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    onAdd() {
      this.$router.push({
        name: "newCustomerWelcomeAdd",
      });
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "newCustomerWelcomeAdd",
        query: {
          id: row.id,
          user_name: row.user_name,
          state: row.state,
        },
      });
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/AssistantWelcomeNew/delWelcome",
              qs.stringify({
                account_id: this.tooken.account_id,
                id: row.id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.tableData = [];
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSearch() {
      this.getData();
    },
  },
};
</script>
<style  scoped>
/* .materialAdmin {
  overflow-y: auto;
} */
.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}
.header-menu {
  margin: .0rem 0 2.0rem 0;
  display: flex;
  justify-content: space-between;
}
.menu-right {
  margin-left: 2.4rem;
  display: flex;
  width: 18%;
}
.menu-select {
  margin-right: 1.6rem;
}

::v-deep .el-table__header-wrapper thead tr {
  background-color: #f2f2f2 !important;
  /* color: #fff; */
}
.cont {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 3.0rem;
  font-size: 1.5rem;
}
</style>
